import { FunctionComponent } from 'react';
import Image from "next/legacy/image";

interface CallOutButtonProps {
  label: string;
  icon: string;
  onClick?: () => void;
}

const CallOutButton: FunctionComponent<CallOutButtonProps> = ({
  label,
  icon,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className="flex items-center justify-center p-2 mx-1 text-xs bg-white border-l-4 md:text-sm border-primary text-primary"
    >
      <Image
        src={icon}
        blurDataURL={icon}
        layout="responsive"
        loading="eager"
        placeholder="blur"
        width={2500}
        height={2000}
        alt=""
      />
      &nbsp;
      <p className="font-bold font-heading">{label}</p>
    </div>
  );
};

export default CallOutButton;
